import React, { useState } from 'react'
import SearchInput from '../../../shared/SearchInput'
const ResidenceHeader = ({status,setstatus}) => {
  return (
    <div className=''>
       <h4 className='ResidenceHeader--h4'>اقامتگاه های سایت</h4>
    <div className='flex ResidenceHeader  justify-between items-center'>
       
        <div className="flex gap-[36px] ">
                {/* <button><img src={message}/></button> */}
                <SearchInput />
            </div>
        <div className='flex gap-[36px] items-center  '>
         <button onClick={()=>setstatus("verified")} className={`ResidenceHeader--button ${ status ==="verified"? "ResidenceHeader--button--active" :""}`}>اقامتگاه های تایید شده</button>
         <button  onClick={()=>setstatus("unverified")} className={`ResidenceHeader--button ${status==="unverified"?"ResidenceHeader--button--active":""}`}>اقامتگاه های تایید نشده</button>
         <button  onClick={()=>setstatus("pending")} className={`ResidenceHeader--button ${status === "pending"?"ResidenceHeader--button--active":""}`}>در انتظار تایید</button>
        </div>
    </div>
    </div>
  )
}

export default ResidenceHeader